import { createResourceApi } from 'resources/ResourceApi';
import { PartnerApiItem } from 'typings/api';

export default createResourceApi<PartnerApiItem>('partners');
